export default __webpack_public_path__ + "static/media/interior.bad16a6a.webp";